var map = {
	"./VAvatar.vue": "89db",
	"./VBalanceList.vue": "7766",
	"./VChatBox.vue": "8f35",
	"./VCoinSendModal.vue": "ee42",
	"./VFooter.vue": "1a98",
	"./VHeader.vue": "a369",
	"./VJoinUs.vue": "9fdb",
	"./VMentionedUsers.vue": "2cef",
	"./VNotificationList.vue": "9b1c",
	"./VPageSwiper.vue": "b043",
	"./VProductLinks.vue": "4a0a",
	"./VPurchaseEntry.vue": "4ee5",
	"./VQrCodeDialog.vue": "c747",
	"./VRequest.vue": "a419",
	"./VShare.vue": "502e",
	"./VSwiper.vue": "0581",
	"./VTag.vue": "f53f",
	"./VTaskCommentEditor.vue": "5058",
	"./VTaskCommentItem.vue": "9d28",
	"./VTaskCommentModal.vue": "299f",
	"./VTaskComments.vue": "9dfe",
	"./VTaskList.vue": "661e",
	"./VTaskReplyList.vue": "09e1",
	"./VTaskRewards.vue": "16cb",
	"./VTaskSubscribe.vue": "34de",
	"./VTaskTags.vue": "05ce",
	"./VTimer.vue": "9d92",
	"./VUpload.vue": "b3a4",
	"./VUserGroup.vue": "8680",
	"./VVideo.vue": "f976",
	"./VVote.vue": "05b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffe0";